var Interface = require('../core');
var _ = require('lodash');

Interface.preprocessor('reverse-side-load-lookup', {
  convertToSource: function (sync, dtdReq) {
    _.each(sync, function (o) {
      delete o[dtdReq.hint.writeProperty];
    });

    return sync;
  },

  /**
   * resource_detail: {
   *   resource: 1
   * },
   * resource: {
   *   "1": {
   *     resource_detail: <lookup>
   *   }
   * }
   */
  convertToSync: function (source, dtdReq, dtdQueue) {
    var requestArray = false;
    var conversionFn = _.identity;
    var reverseLookup = {};
    var rootDtd = dtdQueue[0];
    var lookup = rootDtd[dtdReq.hint.readHash];

    _.each(lookup, function (o, key) {
      var readValue = o[dtdReq.hint.readProperty];

      reverseLookup[readValue] = reverseLookup[readValue] || {};
      reverseLookup[readValue][key] = o;
    });

    requestArray = dtdReq.typeDef[dtdReq.hint.writeProperty] === 'array';

    dtdReq.typeDef = dtdReq.typeDef || {};
    dtdReq.typeDef[dtdReq.hint.writeProperty] = requestArray ? 'array' : 'object';

    conversionFn = requestArray ? _.toArray : _.identity;

    _.each(source, function (sourceValue, sourceKey) {
      sourceValue[dtdReq.hint.writeProperty] = conversionFn.call(_, reverseLookup[sourceKey]);
    });

    return source;
  }
});



// WEBPACK FOOTER //
// ./app/vendor/utility-js-interface/src/preprocessors/reverse_side_load_lookup.js